import { render, staticRenderFns } from "./ConfirmDeleteModalComponent.vue?vue&type=template&id=290bb1fc"
import script from "./ConfirmDeleteModalComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports